// extracted by mini-css-extract-plugin
export default {"ScreenXXSMax":"(max-width: 543px)","row":"G217b2a","dropDownContainer":"Ga53ee2","editDeliveryOuterContainer":"Gc50fac"};